import React from 'react';

import { type match } from 'react-router-dom';

import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';

import RecordTransition from '../components/RecordTransition';
import WorkedOnPage from '../components/WorkedOnPage/lazy';

interface UserProfileWorkedOnMatchParams {
	userId: string;
}

const UserProfileWorkedOn = ({ match }: { match: match<UserProfileWorkedOnMatchParams> }) => {
	const { userId } = match.params;
	return (
		<>
			<RecordTransition name={AnalyticsKeys.PROFILE_WORKED_ON_PAGE_VIEW} />
			<TrackPageLoad name={AnalyticsKeys.PROFILE_WORKED_ON_PAGE_VIEW} />
			<WorkedOnPage userId={decodeURIComponent(userId)} />
		</>
	);
};

export default UserProfileWorkedOn;
